import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-131" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-132" data-mp="34bsggjxt7rj0">
        <SectionTag icon="📦" data-id="element-133" data-mp="30ays5pgggapl">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-134" data-mp="30cjljbr19nlv">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-135" data-mp="2qmgtpevnefp4">
          Recibirás en tu correo el enlace de acceso al material descargable. Puedes consultar los PDF en
          móvil, tablet u ordenador e imprimir las fichas en A4.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-136" data-mp="2clw8yd66a9sz">
        <ScrollHintTable minWidth="420px" data-id="element-137" data-mp="2cnqyk4se2q3e">
          <table className="w-full text-left text-sm" data-id="element-138" data-mp="35o6l2ouziver">
            <thead data-id="element-139" data-mp="35mlqiz8o7cgw">
              <tr className="border-b border-gris-claro bg-bg-secondary text-xs uppercase tracking-wide text-muted" data-id="element-140" data-mp="3afexltrm2ww5">
                <th className="px-5 py-3 font-semibold" data-id="element-141" data-mp="2vr0vjl20rcgn">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-142" data-mp="2voo3gf2jrlpv">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-143" data-mp="30q52s65dv04c">Páginas</th>
              </tr>
            </thead>
            <tbody className="bg-white" data-id="element-144" data-mp="3ofprl5o7wrlj">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-gris-claro' : ''} data-id="element-145" data-mp="3tcy52syf87gg" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-azul-dark" data-id="element-146" data-mp="3fe8c9pimwtxw">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-147" data-mp="3jea291f0byxc">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-naranja" data-id="element-148" data-mp="23y9umx9e4zl2">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <p className="mt-4 text-center text-sm font-semibold text-naranja" data-id="element-149" data-mp="eh61vnbqc2oh">Total: 11 PDF · 414 páginas</p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-150" data-mp="9kfj2s8jiszd">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-gris-oscuro" data-id="element-151" data-mp="4ql05r0rei1c">
              <CheckIcon size={16} className="text-success" data-id="element-152" data-mp="3vyfed4w4pdq8" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}